import './course_item.css';
import imagePlaceholder from '../../assets/img/jpg/img_placeholder.jpg';
import { forwardRef, useEffect, useState } from "react";
import { backendEnv } from '../../env';
import { useLang } from '../../context/LangContext';
import { useNavigate } from 'react-router-dom';

export const CourseItem = forwardRef(({course}, ref) => {
    const { lang } = useLang();
    const navigate = useNavigate();

    const [image, setImage] = useState(imagePlaceholder);

    const goToCourse = () => {
        navigate('/course/' + course.id, {replace: true, state: {course: course}});
    }

    useEffect(() => {
        if (course !== null) {
            setImage(backendEnv.url + '/api/public/v1/course/'+course.id+'/image/get');
        }
    }, [course]);

    return (
        <div className='course_item' onClick={goToCourse}>
            <div className='image'>
                <div className='hover_container'>
                    <button onClick={goToCourse}>
                        { lang === "en" ? "VIEW ACADEMY" : "VER ACADEMIA" }
                    </button>
                </div>
                {
                    course.picture !== null ? <img src={image} alt='' /> : <img src={imagePlaceholder} alt='' />
                }
            </div>
            <div className='title'>
                <p>
                    {
                        course.en && lang === "en" ? course.en.name : course.name
                    }
                </p>
            </div>
        </div>
    );
});